import { render, staticRenderFns } from "./FaIcon.vue?vue&type=template&id=eb363f68&scoped=true&"
import script from "./FaIcon.vue?vue&type=script&lang=js&"
export * from "./FaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb363f68",
  null
  
)

export default component.exports